// import { Box, styled, Button } from "@mui/system";
import React, { useState } from 'react'
import { Button, styled, Box, TextField, Drawer } from '@mui/material'
import { helpGetUserLoginAccountWithEmail } from '../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail'
import StepperDetailsUser from '../RightModals/DetailsUser'
import { useNavigate, useParams } from 'react-router-dom'
import { getSubscriberUserCorpEntities } from '../../../app/services/Suscriber/getSubscriberUserCorpEntities'
import { useDispatch } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar
} from '../../../redux/actions/app'

// import useStyleSearchUser from './useStyleSearchUser'
const InputContainer = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  // top
  padding: '5% 0% 0% 7%',
  '@media all and (max-width: 700px)': {
    width: '80%'
  }
}))

const BoxInput = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  color: '#4B4952',
  fontSize: 18,
  fontFamily: 'roboto',
  '@media all and (max-width: 700px)': {
    width: '100%'
  }
}))

const BoxRoot = styled(Box)(() => ({
  width: '100%',
  overflow: 'hidden'
}))

const InputButton = styled(Button)(() => ({
  background: '#1C846F',
  '&:hover': {
    background: '#0CABA8'
  },
  borderRadius: '5rem',
  color: '#fff'
}))

export const SearchUser = ({ setLoading }) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [user, setUser] = useState(null)
  const [error, seterror] = React.useState(false)
  const [stateUserDetails, setStateUserDetails] = React.useState(false)
  const [countSubscribersAsociate, setcountSubscribersAsociate] = useState(0)

  const handleChangeEmail = (event) => {
    seterror(false)
    setEmail(event.target.value)
  }

  const searchUser = () => {
    if (id === email && !error) {
      handleGetUser()
    } else {
      navigate(`/users/${email}`)
    }
  }

  const handleSearchSubmit = (event) => {
    if (event.type === 'keydown' && event.key === 'Enter' && email !== '') {
      searchUser()
    }
  }

  React.useEffect(async () => {
    if (id) {
      setEmail(id)
      await handleGetUser(id)
    }
  }, [id])

  // get user request and get subscribers count for user
  const handleGetUser = async (param = email) => {
    setLoading(true)
    setcountSubscribersAsociate(0)
    try {
      const response = await helpGetUserLoginAccountWithEmail(param)
      setUser(response.data?.loginAccount)

      await handleGetSuscribers(response.data?.loginAccount?.organizationUsers)
    } catch (err) {
      if (err.response?.data?.error?.message !== 'Verify LoginAccount email.') {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
        // error
      }
      seterror(true)
    }
    setLoading(false)
  }

  // set count subscribers
  const handleGetSuscribers = async (organizationUserIDs) => {
    await organizationUserIDs.forEach(async (element) => {
      const response = await isExistsSuscriberAsociate(element.userId)
      setcountSubscribersAsociate((state) => state + response)
    })
    setStateUserDetails(true)
  }

  // is exists subscribers return 1 count
  const isExistsSuscriberAsociate = async (userid) => {
    try {
      const response = await getSubscriberUserCorpEntities(userid)
      return response.data?.length > 0 ? response.data?.length : 0
    } catch (error) {
      return 0
    }
  }

  const listDetailsUser = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : '60vw' }}
      role="presentation"
    >
      <StepperDetailsUser
        style={{ marginTop: '5%' }}
        setStateUserDetails={setStateUserDetails}
        user={user}
        countSubscribersAsociate={countSubscribersAsociate}
      />
    </Box>
  )
  return (
    <BoxRoot>
      <InputContainer>
        <BoxInput>
          <div style={{ fontWeight: 'lighter' }}>
            Ingrese el email del usuario que desea buscar:
          </div>
        </BoxInput>
        <TextField
          value={email}
          onChange={handleChangeEmail}
          onKeyDown={handleSearchSubmit}
          placeholder={'Ej: persona@mail.com'}
          error={error}
          helperText={error ? 'No se encontró el usuario ingresado.' : ''}
        />
        <InputButton onClick={searchUser}>Buscar</InputButton>
      </InputContainer>
      <Drawer anchor={'right'} open={stateUserDetails}>
        {listDetailsUser('right')}
      </Drawer>
    </BoxRoot>
  )
}
